import { useEffect } from 'react';
import { isRouteErrorResponse, useRouteError } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import ErrorFallback from './ErrorFallback';

export default function RouteErrorFallback() {
  const error = useRouteError();

  useEffect(() => {
    // Report to Sentry
    if (error instanceof Error) {
      Sentry.captureException(error);
    } else if (!isRouteErrorResponse(error)) {
      Sentry.captureMessage(`Route error: ${String(error)}`);
    }
  }, [error]);

  const errorObj = error instanceof Error ? error : new Error(String(error));

  return <ErrorFallback error={errorObj} />;
}
